import React from 'react'
import type { PasswordCriteria } from '../utils'

interface PasswordCriteriaListProps {
  criteria: PasswordCriteria
}

const CRITERIA_LABELS: { key: keyof PasswordCriteria; label: string }[] = [
  { key: 'minLength', label: 'Au moins 8 caractères' },
  { key: 'hasUppercase', label: 'Une lettre majuscule' },
  { key: 'hasLowercase', label: 'Une lettre minuscule' },
  { key: 'hasDigit', label: 'Un chiffre' },
  { key: 'hasSpecialChar', label: 'Un caractère spécial' },
]

export const PasswordCriteriaList: React.FC<PasswordCriteriaListProps> = ({ criteria }) => {
  return (
    <ul className="password-criteria" aria-live="polite" aria-label="Exigences du mot de passe">
      {CRITERIA_LABELS.map(({ key, label }) => {
        const met = criteria[key]
        return (
          <li
            key={key}
            className={`password-criterion ${met ? 'password-criterion--valid' : 'password-criterion--invalid'}`}
          >
            <span className="password-criterion-icon" aria-hidden="true">
              {met ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              )}
            </span>
            <span>{label}</span>
          </li>
        )
      })}
    </ul>
  )
}
